import { useSelector } from 'react-redux';
import { changeNum } from '../../common/function';
import '../../css/app.css'
import '../../css/common.css'
import { useState, useEffect, useRef, useLayoutEffect } from 'react';
import { Link, useNavigate } from "react-router-dom"
import { ClipLoader } from "react-spinners";

function DownloadBtn({ text, onClick, height = "36px", state = true }) {
    return (
        <div className="excel_download" onClick={state ? onClick : undefined} style={{ opacity: state ? "1" : "0.7", position: "relative" }}>
            <img src='/img/excel_img.png' className='btn btn-outline-secondary' style={{ height: height, padding: '0', cursor: state ? "pointer" : "auto" }} />
            {!state &&
                <div style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)" }}>
                    <ClipLoader color="#003577" />
                </div>}
            {/* <button className="dropdown-toggle btn btn-outline-secondary" id="paytable1" aria-expanded="true">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" icon-name="download" data-lucide="download" className="lucide lucide-download">
                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                    <polyline points="7 10 12 15 17 10"></polyline>
                    <line x1="12" y1="15" x2="12" y2="3"></line>
                </svg>
                {text}
            </button> */}
        </div>
    )
}

function CountSelect({ onChange, maxFirstPage }) {
    return (
        <div className="rows_per_page">
            <select
                id="page_size"
                className="form-select select_status"
                onChange={onChange}
                value={maxFirstPage}
            >
                <option value="10">10개씩 보기</option>
                <option value="20">20개씩 보기</option>
                <option value="30">30개씩 보기</option>
                <option value="50">50개씩 보기</option>
                <option value="100">100개씩 보기</option>
            </select>
        </div>
    )
}


function TotalAmountCount({ confirm_amt, confirm_cnt, canceled_amt, canceled_cnt }) {
    return (
        <>
            <div className="input_wrap d_none" style={{ background: "#d7e3cf", flexDirection: 'column' }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', marginBottom: '5px' }}>
                    <label>승인금액 :</label>
                    <input id="confirm_amt" type="text" className="form-control" value={`${confirm_cnt}건`} readonly="" disabled="" style={{ textAlign: "right" }} />
                </div>
                <input id="confirm_amt" type="text" className="form-control" value={`${changeNum(confirm_amt)}원`} readonly="" disabled="" style={{ textAlign: "right" }} />
            </div>
            <div className="input_wrap d_none" style={{ background: "#fcd9d6", flexDirection: 'column' }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', marginBottom: '5px' }}>
                    <label>취소금액 :</label>
                    <input id="confirm_amt" type="text" className="form-control" value={`${canceled_cnt}건`} readonly="" disabled="" style={{ textAlign: "right" }} />
                </div>
                <input id="canceled_amt" type="text" className="form-control" value={`${changeNum(canceled_amt)}원`} readonly="" disabled="" style={{ textAlign: "right" }} />
            </div>
            <div className="input_wrap" style={{ background: "#d2e4fb", flexDirection: 'column' }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', marginBottom: '5px' }}>
                    <label>합계 :</label>
                    <input id="confirm_amt" type="text" className="form-control" value={`${confirm_cnt + canceled_cnt}건`} readonly="" disabled="" style={{ textAlign: "right" }} />
                </div>
                <input id="tot_amt" type="text" className="form-control" value={`${changeNum(confirm_amt - canceled_amt)}원`} readonly="" disabled="" style={{ textAlign: "right" }} />
            </div>
        </>
    )
}

function TotalAmount({ confirm_amt, canceled_amt }) {
    return (
        <>
            <div className="input_wrap d_none" style={{ background: "#d7e3cf" }}>
                <label>승인금액 :</label>
                <input id="confirm_amt" type="text" className="form-control" value={`${changeNum(confirm_amt)}원`} readonly="" disabled="" />
                {/* <button type="button" className="btn_more">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" icon-name="chevron-down" data-lucide="chevron-down" className="lucide lucide-chevron-down"><polyline points="6 9 12 15 18 9"></polyline></svg>
                </button> */}
            </div>
            <div className="input_wrap d_none" style={{ background: "#fcd9d6" }}>
                <label>취소금액 :</label>
                <input id="canceled_amt" type="text" className="form-control" value={`${changeNum(Math.abs(canceled_amt))}원`} readonly="" disabled="" />
            </div>
            <div className="input_wrap" style={{ background: "#d2e4fb" }}>
                <label>합계 :</label>
                <input id="tot_amt" type="text" className="form-control" value={`${changeNum(confirm_amt + canceled_amt)}원`} readonly="" disabled="" />
            </div>
        </>
    )
}

function TotalPayAmount({ instant_terminal_amt, normal_terminal_amt, manual_amt, pgSelect }) {
    return (
        <>
            {
                (pgSelect === 0 || pgSelect === 2) && (
                    <div className="input_wrap d_none" style={{ background: "#bdcdd6" }}>
                        <label>즉결단말기 :</label>
                        <input id="instant_terminal_amt" type="text" className="form-control" value={`${changeNum(pgSelect === 0 ? instant_terminal_amt : instant_terminal_amt + normal_terminal_amt)}원`} readonly="" disabled="" />
                    </div>
                )
            }
            {
                (pgSelect === 0 || pgSelect === 1) && (
                    <div className="input_wrap d_none" style={{ background: "#bdcdd6" }}>
                        <label>익일단말기 :</label>
                        <input id="normal_terminal_amt" type="text" className="form-control" value={`${changeNum(pgSelect === 0 ? normal_terminal_amt : instant_terminal_amt + normal_terminal_amt)}원`} readonly="" disabled="" />
                    </div>
                )
            }
            {
                (pgSelect === 0 || pgSelect === 1 || pgSelect === 2) && (
                    <div className="input_wrap d_none" style={{ background: "#bdcdd6" }}>
                        <label>수기 :</label>
                        <input id="manual_amt" type="text" className="form-control" value={`${changeNum(manual_amt)}원`} readonly="" disabled="" />
                    </div>
                )
            }
        </>
    )
}

function SettlementAmount({ totalAmount, settlementAmount, totalFee, sugiAmount, merchantAmount, agencyAmount, orgAmount }) {
    let MyData = useSelector((state) => { return state.MyData })
    return (
        <>
            <div className="input_wrap d_none" style={{ background: "#d7e3cf" }}>
                <label>단말기 :</label>
                <input id="confirm_amt" type="text" className="form-control" value={`${changeNum(settlementAmount ?? 0)}원`} readonly="" disabled="" />
                {/* <button type="button" className="btn_more">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" icon-name="chevron-down" data-lucide="chevron-down" className="lucide lucide-chevron-down"><polyline points="6 9 12 15 18 9"></polyline></svg>
                </button> */}
            </div>
            {
                MyData?.role == "SUPER"
                    ?
                    <div className="input_wrap d_none" style={{ background: "#d7e3cf" }}>
                        <label>수기 :</label>
                        <input id="confirm_amt" type="text" className="form-control" value={`${changeNum(sugiAmount ?? 0)}원`} readonly="" disabled="" />
                    </div>
                    :
                    ""
            }
            <div className="input_wrap" style={{ background: "#d2e4fb" }}>
                <label>정산액 :</label>
                <input id="canceled_amt" type="text" className="form-control" value={`${changeNum(merchantAmount ?? 0)}원`} readonly="" disabled="" />
            </div>
            <div className="input_wrap d_none" style={{ background: "#bdcdd6" }}>
                <label>수수료 :</label>
                <input id="tot_amt" type="text" className="form-control" value={`${changeNum(totalFee ?? 0)}원`} readonly="" disabled="" />
            </div>
            {
                MyData?.role == "SUPER"
                    ?
                    <div className="input_wrap d_none" style={{ background: "#bdcdd6" }}>
                        <label>대행사 :</label>
                        <input id="tot_amt" type="text" className="form-control" value={`${changeNum(agencyAmount ?? 0)}원`} readonly="" disabled="" />
                    </div>
                    :
                    ""
            }
            {
                MyData?.role == "SUPER"
                    ?
                    <div className="input_wrap d_none" style={{ background: "#bdcdd6" }}>
                        <label>상단 :</label>
                        <input id="tot_amt" type="text" className="form-control" value={`${changeNum(orgAmount ?? 0)}원`} readonly="" disabled="" />
                    </div>
                    :
                    ""
            }
        </>
    )
}

function CountAmount({ tableBodyData }) {
    let len = 0
    if (Array.isArray(tableBodyData)) {
        len = tableBodyData.length;
    } else {
        len = tableBodyData;
    }
    return (
        <div className="tabulator_total_cnt_wrap">
            <input id="total_cnt" type="text" value={`${len}건`} readonly="" />
        </div>
    )
}

function CountAmountLeft({ tableBodyData, textAlign = "left" }) {
    let len = 0
    if (Array.isArray(tableBodyData)) {
        len = tableBodyData.length;
    } else {
        len = tableBodyData;
    }
    return (
        <div class="excel_download">
            <div class="tabulator_total_cnt_wrap">
                <input id="total_cnt" type="text" value={`${len}건`} readonly="" style={{ textAlign: textAlign }} />
            </div>
        </div>
    )
}

export { DownloadBtn, CountSelect, TotalAmount, TotalAmountCount, CountAmount, CountAmountLeft, SettlementAmount, TotalPayAmount }